"use client";

/* eslint-disable react/jsx-props-no-spreading */
import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import ConfirmationSection from "@/components/organisms/confirmation-section/confirmation-section";
import { CombinedConfirmation } from "@/utils/schema/confirmation-page-schema.utils";

import { useConfirmationPageData } from "./confirmation.hook";

function ConfirmationPage(props: Readonly<CombinedConfirmation>) {
  const { current } = useWizard();
  useConfirmationPageData({
    progressBarPercent: current?.progressBarPercentage ?? -1,
  });

  return (
    <div
      data-testid="confirmationPage-test-id"
      className=" bg-surface-neutral-option-2 "
    >
      <div>
        <ConfirmationSection {...props} />
      </div>
    </div>
  );
}

export default ConfirmationPage;
